<template>
  <div class="tacticsBox">
    <el-row style="background: #ffffff;" class="shadow">
      <h3 class="tactics">收益分析</h3>
      <el-col :span="24">
        <div style="min-width:1400px;height:430px;margin-left:69px;">
          <tracharts
            :startID="'loss'"
            :kechartsData="lossData"
            :title="'因子组合主动收益率'"
            :types="true"
            ref="lossData"
          ></tracharts>
        </div>
      </el-col>
      <el-col :span="24">
        <div style="min-width:1400px;height:430px;margin-left:69px;">
          <tracharts
            :startID="'list'"
            :title="'因子多空组合收益率'"
            :kechartsData="sFactor"
            :types="false"
            ref="lossData1"
          ></tracharts>
        </div>
      </el-col>
    </el-row>

    <el-row style="background: #ffffff;margin-top:20px;" class="shadow">
      <h3 class="tactics">换手率分析</h3>
      <el-col :span="24">
        <div style="min-width:1400px;height:430px;margin-left:69px;">
          <sameEcharts ref="sameEcharts" :startID="'loss1'" :kechartsData="sameData" :types="true"></sameEcharts>
          <!-- <tracharts :startID="'lossData1'" :kechartsData="sFactor" :types="false" ref="lossData1"></tracharts> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// common/kecharts
import tracharts from "./common/tracharts";
import sameEcharts from "./common/sameEcharts";
// import kecharts from "../../strategy/common/kecharts";
export default {
  components: { tracharts, sameEcharts },
  props: {
    getData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lossData: {
        dataValue: [],
        tiem: []
      },
      sCombinPerm: {},
      sFactorPerm: {},
      sParam: {},
      sFactor: {}, // 因子收益
      sameData: {
        dataValue: [],
        tiem: []
      } // 换手率分析
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    reset() {
      this.lossData = {
        dataValue: [],
        tiem: []
      };
      this.sameData = {
        dataValue: [],
        tiem: []
      };
    },
    init() {
      this.reset();
      this.sCombinPerm = this.getData.sCombinPerm;
      this.sFactorPerm = this.getData.sFactorPerm;
      this.sParam = JSON.parse(JSON.stringify(this.getData.sParam));
      this.getData.listTeamYiled.forEach((element, idx) => {
        this.lossData.dataValue.push({
          value: element,
          name: `第${idx + 1}组`
        });
      });
      this.lossData.tiem = this.getData.listTimeLine;
      // 收益分析
      this.sFactor = {
        tiem: this.getData.listTimeLine,
        name: "因子多空组合收益率",
        value: this.getData.listExtraYield
      };
      // 换手率分析
      this.getData.listTurnOverRate.forEach((element, idx) => {
        this.sameData.dataValue.push({
          value: element,
          name: `第${idx + 1}组`
        });
      });
      this.sameData.tiem = this.getData.listTimeLine;
      // 换手率分析
      this.$nextTick(() => {
        this.$refs.lossData.echartsInit();
        this.$refs.lossData1.echartsInit();
        this.$refs.sameEcharts.echartsInit();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tacticsBox {
  .tactics {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    height: 42px;
    line-height: 42px;
    background: rgba(240, 242, 245, 1);
    box-shadow: 0px 0px 8px 0px rgba(239, 242, 255, 1);
    text-shadow: 0px 0px 4px rgba(214, 234, 255, 1);
    padding-left: 10px;
  }
  .UlTOP {
    margin: 34px 0px 33px 48px;
    li:first-child {
      height: 110px;
    }
    li {
      color: #666666;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      border-bottom: 1px solid #dddddd;
      height: 32px;
      line-height: 32px;
      h4 {
        color: #666666;
        font-size: 12px;
        font-weight: bold;
      }
      h3 {
        font-size: 35px;
        font-weight: 400;
        line-height: 50px;
      }
    }
    .ulRed {
      color: #ff5454;
    }
    .ulBule {
      color: #1482f1;
    }
  }
  .pgUp {
    color: #f15a5a;
  }
  .pgDn {
    color: #1bb10a;
  }
  .tacticsUl {
    margin: 0 14px;
    li {
      color: #666666;
      display: inline-block;
      width: 20%;
      text-align: center;
      p:nth-child(1) {
        margin: 18px 0;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
      }
    }
  }
  .shadow {
    box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
  }
}
</style>
